import { render, staticRenderFns } from "./g-drag-canvas.vue?vue&type=template&id=33cf1142&scoped=true&"
import script from "./g-drag-canvas.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-drag-canvas.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-drag-canvas.vue?vue&type=style&index=0&id=33cf1142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf1142",
  null
  
)

export default component.exports